import {KazBlurImageComponent} from '../kaz-blur-image/kaz-blur-image.component';
import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {Ad, PriceType} from "../../interfaces/ad";
import {getDummyPicture} from "../../utils/dummyImages";
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CurrencyPipe } from '@angular/common';
import { ImageSourcePipe } from '../../pipes/image-source.pipe';

@Component({
    selector: 'kaz-card-default',
    templateUrl: './kaz-card-default.component.html',
    styleUrls: ['./kaz-card-default.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [KazBlurImageComponent, RouterLink, FaIconComponent, CurrencyPipe, ImageSourcePipe]
})
export class KazCardDefaultComponent {
  @Input() ad: Ad | null = null;
  protected readonly getDummyPicture = getDummyPicture;
    protected readonly PriceType = PriceType;
}
